import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;
